export default __webpack_public_path__ + "static/royal_bow-054edcd32ca76fd32b4ff000c0da1745.png";